import { render, staticRenderFns } from "./ObjectTypes.vue?vue&type=template&id=71b843a8&"
import script from "./ObjectTypes.vue?vue&type=script&lang=js&"
export * from "./ObjectTypes.vue?vue&type=script&lang=js&"
import style0 from "./ObjectTypes.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports